import { computed } from 'vue'
import { useVisibilityStore } from '@/visibility/visibility.store'

export function useNonAIMode() {
  const visibilityStore = useVisibilityStore()
  return computed(() => !visibilityStore.aiFeatureVisibility)
}
